/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {
    equalWidth: {
      description: 'Divide the available width equally among `TabsItem`',
      type: 'variant',
      values: [ true ]
    },
    focus: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      description: "The design uses height of 3: there's (rightly) no '3' in the Allium palette but the effect is 1px above and below a 1px line",
      if: { selected: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        color: '#4b286d',
        highlightBarBorderRadius: 32,
        highlightBarBorderWidth: 1,
        highlightBarHeight: 1,
        highlightColor: '#4b286d'
      }
    },
    {
      if: { hover: true },
      tokens: { borderColor: '#b2b9bf', borderWidth: 2 }
    },
    {
      if: { focus: true },
      tokens: { borderColor: '#4b286d', borderWidth: 2, color: '#4b286d' }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#676e73',
        borderColor: 'transparent',
        borderWidth: 0,
        color: '#ffffff'
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { backgroundColor: '#4b286d' }
    },
    {
      if: { inverse: true },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', color: '#ffffff' }
    },
    {
      if: { hover: true, inverse: true },
      tokens: { borderColor: '#ffffff', highlightColor: '#ffffff' }
    },
    {
      if: { inverse: true, selected: true },
      tokens: {
        backgroundColor: '#ffffff',
        color: '#414547',
        highlightColor: '#ffffff'
      }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        backgroundColor: '#ffffff',
        color: '#414547',
        highlightColor: '#ffffff'
      }
    },
    {
      if: { focus: true, inverse: true },
      tokens: { borderColor: '#ffffff', highlightColor: '#ffffff' }
    },
    { if: { equalWidth: true }, tokens: { maxWidth: null } }
  ],
  tokens: {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    borderRadius: 32,
    borderWidth: 0,
    color: '#676e73',
    fontName: 'HNforTELUSSA',
    fontScaleCap: 64,
    fontSize: 14,
    fontWeight: '700',
    highlightBarBorderRadius: 0,
    highlightBarBorderWidth: 0,
    highlightBarHeight: 0,
    highlightColor: 'transparent',
    highlightTriangleSize: 0,
    letterSpacing: 0,
    lineHeight: 1.14285714286,
    marginHorizontal: 0,
    marginVertical: 0,
    maxWidth: 192,
    paddingHorizontal: 24,
    paddingVertical: 8,
    space: 1,
    textAlign: 'center',
    textTransform: 'none'
  }
}
export default theme
